export const ENV = "prod";
export const WEB_URL = "https://zeplin.io";
export const APP_URL = "https://beta.zeplin.io";
export const BASE_URL = "https://api.zeplin.io";
export const IMG_URL = "https://img.zeplin.io";
export const CDN_URL = "https://cdn.zeplin.io";
export const SCENE_URL = "https://scene.zeplin.io";
export const EXTENSIONS_WEB_URL = "https://extensions.zeplin.io";
export const PUSHER_URL = "https://pusher.zeplin.io/v1/auth";
export const PUSHER_URL_V2 = "https://pusher.zeplin.io/v2/auth";
export const SHORTLINK_URL = "https://zpl.io";
export const STAGE_SHORTLINK_URL = "https://stage.zpl.io";
export const APP_URLS = "https://app.zeplin.io,https://beta.zeplin.io".split(",");
export const ASSET_URL_BASE = "https://cdn.zeplin.io/assets/webapp/";
export const PUBLIC_API_URL = "https://api.zeplin.dev";
export const CLI_CLIENT_ID = "5dd27af376f8bf5094f6ebe6";
export const ZEM_CLIENT_ID = "5bbc983af6c410493afb03f1";
export const TRELLO_CLIENT_ID = "59dfedff7c722575736b3e8d";
export const JIRA_CLIENT_ID = "5dc3d464b94b22000d3834d0";
export const JIRA_ATL_ORIGIN_TOKEN = "eyJpIjoiZThlMzc5Y2FhZjQ4NDhhYzk3ZDgxMGY5ZDhmYTExNTkiLCJwIjoiamlyYS16ZXBsaW4taW50In0";
export const VSCODE_CLIENT_ID = "5dc51cd876f8bf00163de1e5";
export const FIGMA_CLIENT_ID = "5f16c22ce92f41f029ff9593";
export const FIGMA_LOGIN_CLIENT_ID = "BGBq9gsydDcp750jScX7NV";
export const FIGMA_AUTH_GET_TOKEN_REDIRECT_URI = "https://beta.zeplin.io/auth/figma/token";
export const FIGMA_AUTH_LOGIN_REDIRECT_URI = "https://beta.zeplin.io/auth/figma/login";
export const FIGMA_AUTH_SIGNUP_REDIRECT_URI = "https://beta.zeplin.io/auth/figma/signup";
export const FIGMA_AUTH_UNLINK_REDIRECT_URI = "https://beta.zeplin.io/auth/figma/unlink";
export const EMBED_CLIENT_ID = "603e27cd0d0f5dad87e79642";
export const AZURE_DEVOPS_CLIENT_ID = "6475b5d2ea74a15b653f7608";
export const ZPL_PROTOCOL = "zpl-beta:";
export const INTERCOM_APP_ID = "41ycdg94";
export const GOOGLE_CLIENT_ID = "572614822654-ghfhpjmi208r3tcia7ff0tu8p0fg7vdh.apps.googleusercontent.com";
export const GOOGLE_AUTH_LOGIN_REDIRECT_URI = "https://beta.zeplin.io/auth/google/login";
export const GOOGLE_AUTH_SIGNUP_REDIRECT_URI = "https://beta.zeplin.io/auth/google/signup";
export const GOOGLE_AUTH_UNLINK_REDIRECT_URI = "https://beta.zeplin.io/auth/google/unlink";
export const GOOGLE_AUTH_SETUP_SSO_REDIRECT_URI = "https://beta.zeplin.io/auth/google/setupsso";
export const GOOGLE_AUTH_REMOVE_SSO_REDIRECT_URI = "https://beta.zeplin.io/auth/google/removesso";
export const INTEGRATION_JIRA_URL = "https://zpl.io/jira";
export const INTEGRATION_TEAMS_URL = "https://zpl.io/zeplin-teams-app";
export const INTEGRATION_TRELLO_URL = "https://trello.com/power-ups/59e0018ea9b5b298bbe8f8ef";
export const FIREBASE_API_KEY = "AIzaSyAJ7h6d1DnbtYRlODr_FZhw8loCsu7n9H8";
export const FIREBASE_PROJECT_ID = "zeplin-8d650";
export const FIREBASE_APP_ID = "1:290381624317:web:0f6a4fd50c15b00d401f94";
export const FIREBASE_MESSAGING_SENDER_ID = "290381624317";
export const MIXPANEL_MASTER_API_TOKEN = "26bd4a3dcc47c8a293c60fa00656fb81";
export const GA_TRACKING_ID = "UA-51352708-8";
export const AD_CONVERSION_ID = "AW-851228751";
export const SIGN_UP_CONVERSION = "HZhrCKmI8b0CEM_w8pUD";
export const SIGN_UP_FIGMA_DESIGNER_CONVERSION = "FBS7CKKMuZIYEM_w8pUD";
export const ORG_PURCHASE_CONVERSION = "JA_4CO64gb4CEM_w8pUD";
export const ADVANCED_PURCHASE_CONVERSION = "{{ADVANCED_PURCHASE_CONVERSION}}";
export const ENT_INQUORY_CONVERSION = "XVsoCNjYgb4CEM_w8pUD";
export const TEAM_PURCHASE_CONVERSION = "ds-ICNfigr4CEM_w8pUD";
export const LINKEDIN_CONVERSION_ID = "8348284";
export const LINKEDIN_FIGMA_DESIGNER_CONVERSION_ID = "11440212";
export const TWITTER_CONVERSION_ID = "o98lu";
export const TIKTOK_PIXEL_ID = "CC1U623C77U2GLNDQVE0";
export const REDDIT_PIXEL_ID = "a2_ekqli49ovoit";
export const STRIPE_PUBLISHABLE_KEY = "pk_live_XfHC5uYDKaZYEOC1m9FlXwtq";
export const SENTRY_DSN = "https://005c26d193b24ce099639f75fb5fbc85@app.getsentry.com/83039";
export const SENTRY_ENVIRONMENT = "beta";
export const PUSHER_ACCESS_KEY = "12ddd9afec9f9b421244";
export const PUSHER_SERVER_URL = "ws.zeplin.io";
export const USER_CHANNEL_PREFIX = "private-user@";
export const PROJECT_CHANNEL_PREFIX = "private-project@";
export const STYLEGUIDE_CHANNEL_PREFIX = "private-styleguide@";
export const ORGANIZATION_CHANNEL_PREFIX = "private-organization@";
export const COOKIE_DOMAIN = ".zeplin.io";
export const SECURE_COOKIE = "true" === "true";
export const S3_BUCKET = "zeplin";
export const FLAG_REMOVE_TEST_ID = "true";
export const FLAG_USE_CONSOLE_LOGGER = "";
export const FLAG_NEW_PUSHER_AUTH = "true" === "true";
export const FLAG_USE_REDUX_DEVTOOLS = "";
export const MARKER_PROJECT_ID = "";
export const TAILWIND_EXTENSION_ID = "6851972d0ab95a934e47a659";
export const CSS_EXTENSION_ID = "5a8b2dc8d81d50e66ae4433b";
export const HTML_EXTENSION_ID = "5a8b2e4ce2201185678e18e6";
export const ZEPLIN_EXTENSIONS_OWNER_USERNAME = "zeplin";
export const FIGMA_API_SCOPE = "current_user:read,file_content:read,library_content:read";